import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {
  addRateFinderBreadcrumb,
  captureRateFinderException,
} from '../../services/rate-finder-sentry';
import {
  claimAssistantFailureReport,
  handleAssistantImportFailure,
  loadAssistantModuleOnce,
} from './app/assistant/assistant-loader';

if (environment.production) {
  enableProdMode();
}

// FRU-21810 perf (measured 7/27): on a direct-Hope entry the assistant chunk's download used to
// start only in rates-form ngOnInit -- AFTER main.js download + the ~420ms Angular bootstrap gap
// (chunk request at t~1.5-1.7s on a throttled phone). Firing the same dynamic import here, at
// main.js EXECUTION time, overlaps the 135KB download with bootstrap itself. The module cache makes
// the later imports in rates-form/openAiAssistant no-op hits. Gated on the exact startAssistant=1
// regex the skeleton uses, so classic/control entries never fetch it.
try {
  if (/[?&]startAssistant=1(?:&|$)/i.test(window.location.search)) {
    addRateFinderBreadcrumb('assistant_chunk_load_start', { source: 'bootstrap_prefetch' });
    loadAssistantModuleOnce().then(() => {
      addRateFinderBreadcrumb('assistant_chunk_load_success', { source: 'bootstrap_prefetch' });
    }).catch((error) => {
      const recoveryAction = handleAssistantImportFailure('bootstrap_prefetch');
      if (claimAssistantFailureReport()) {
        captureRateFinderException(error, 'assistant_chunk_load_failure', {
          source: 'bootstrap_prefetch',
          recovery_action: recoveryAction,
        });
      }
    });
  }
} catch (e) { /* non-fatal */ }

platformBrowserDynamic().bootstrapModule(AppModule)
  // FRU-22418 parent-owned lifecycle: the boot skeleton's watchdog reads this to tell "app alive under the overlay"
  // (lift it -- the classic form works) from "nothing ever booted" (one cache-busted reload).
  .then(() => { try { (window as any).__fruAppBooted = true; } catch (e) { /* non-fatal */ } })
  .catch(err => {
    captureRateFinderException(err, 'app_boot_failure');
    console.log(err);
  });
